// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNWANTED VARIABLE
// MODFIED DATA : 10-09-2025

/* eslint-disable import/no-anonymous-default-export */
import RequestReportActionTypes from './request-report.types';
import { docodeHexResponse } from '../../_common/common.utils';
const INITIAL_STATE = {
	// FETCH REQUEST REPORT DETAILS
	fetchRequestReportDetailsResponse: null,
	fetchRequestReportDetailsArr: [],
	addRequestReportDetailsArr: null,
	// ADD REQUEST REPORT DETAILS
	addRequestReportDetailsResponse: null,
	// DELETE REQUEST REPORT DETAILS
	deleteRequestReportResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/********************* FETCH REQUEST REPORT DETAILS START *********************** */
		case RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_SUCCESS:
			return {
				...state,
				fetchRequestReportDetailsResponse: action.payload,
				fetchRequestReportDetailsArr: docodeHexResponse(
					action.payload,
					'FetchRequestedReportKey',
				),
			};
		case RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_FAILURE:
			return {
				...state,
				fetchRequestReportDetailsResponse: action.payload,
				fetchRequestReportDetailsArr: [],
			};

		case RequestReportActionTypes.FETCH_REQUEST_REPORT_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchRequestReportDetailsResponse: null };
		/********************* FETCH REQUEST REPORT DETAILS END *********************** */

		/********************* ADD REQUEST REPORT DETAILS START *********************** */
		case RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_SUCCESS:
			return {
				...state,
				addRequestReportDetailsResponse: action.payload,
				addRequestReportDetailsArr: docodeHexResponse(
					action.payload,
					'AddRequestedReportKey',
				),
			};

		case RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_FAILURE:
			return {
				...state,
				addRequestReportDetailsResponse: action.payload,
				addRequestReportDetailsArr: [],
			};

		case RequestReportActionTypes.ADD_REQUEST_REPORT_DETAILS_RESPONSE_CHANGED:
			return { ...state, addRequestReportDetailsResponse: null };
		/********************* ADD REQUEST REPORT DETAILS END *********************** */

		/********************* DELETE REQUEST REPORT DETAILS START *********************** */
		case RequestReportActionTypes.DELETE_REQUEST_REPORT_SUCCESS:
			return { ...state, deleteRequestReportResponse: action.payload };

		case RequestReportActionTypes.DELETE_REQUEST_REPORT_FAILURE:
			return { ...state, deleteRequestReportResponse: action.payload };

		case RequestReportActionTypes.DELETE_REQUEST_REPORT_CHANGED:
			return { ...state, deleteRequestReportResponse: null };
		/********************* DELETE REQUEST REPORT DETAILS END *********************** */

		default:
			return state;
	}
};
